export default "/images/fb.svg?3561300d4de3680a7035d1e5bb6059a0";